import { MutationTree } from 'vuex';
import { ActivityStoreType } from '@/types/store/activity-store.type';

export const mutations: MutationTree<ActivityStoreType> = {
  SET_ACTIVITY(state, newValue) {
    state.activity = newValue;
  },
};
